import React from "react";
import PropTypes from "prop-types";
import Head from "next/head";
import Header from "./Header";
import Footer from "./Footer";
import DownloadPopup from "./DownloadPopup";
// import stylesheet from '/static/css/scss/app.sass';

import Notifications from "react-notify-toast";

const Layout = (props) => (
  <div className="viewport d-flex flex-column h-100">
    <Head>
      <meta property="og:title" content={props.fbtitle} />
      <meta
        property="og:image"
        content="https://jobs.unnanu.com/static/banners/og-image@1x.png"
      />
      <meta property="og:description" content={props.fbdescription} />
      <meta property="og:url" content={props.fburl} />
      <meta property="og:site_name" content="Unnanu.com" />
      <meta property="og:type" content="website" />
      <meta name="twitter:title" content="Unnanu" />
      <title>
        {" "}
        {props.title !== "Unnanu Jobs"
          ? `Unnanu Jobs - ${props.title}`
          : props.title}{" "}
      </title>
    </Head>
    <Header
      enableSearch={props.showSearch}
      urlDetails={props.urlDetails}
      userData={props.userData}
      deviceInfo={props.deviceInfo}
      cookie={props.cookie}
    />
    {!props.userData.isLogged && (
      <DownloadPopup deviceInfo={props.deviceInfo} />
    )}
    <Notifications options={{ zIndex: 100000, top: "50px", timeout: 3000 }} />
    <main>{props.children}</main>
    <Footer />
  </div>
);

Layout.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
  title: PropTypes.string,
  showSearch: PropTypes.bool,
  fburl: PropTypes.string,
  fbtitle: PropTypes.string,
  fbdescription: PropTypes.string,
};

Layout.defaultProps = {
  title: "Unnanu Jobs",
  showSearch: true,
  fburl: "https://jobs.unnanu.com",
  fbtitle: "Let's find the job you deserve.",
  fbdescription:
    "Connecting outstanding people with the world’s most innovative companies.",
};

export default Layout;



// WEBPACK FOOTER //
// ./components/Layout.js